import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import Camera from '@/assets/svgs/permission/camera.svg';
import ImgPicker from '@/assets/svgs/permission/img-picker.svg';
import Location from '@/assets/svgs/permission/location.svg';
import Notification from '@/assets/svgs/permission/notification.svg';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import type { DeviceTokenData } from '@/stores/DeviceStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { getAppStoreUrls } from '@/utils/appDownload';
import { useHandleApp } from '../_hooks/useHandleApp';
import { MESSAGE_KEYWORD } from '../_utils/reserved-keywords';
export const AppModal = () => {
  const $ = _c(59);
  const [appModal, setAppModal, setTempDeviceTokenData, osType] = useDeviceInfoStore(useShallow(_temp));
  const {
    isOpened,
    type
  } = appModal;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: MESSAGE_KEYWORD.EXIT_APP
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    request: requestExit
  } = useHandleApp(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: MESSAGE_KEYWORD.RESTART_APP
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    request: requestRestart
  } = useHandleApp(t1);
  let t2;
  if ($[2] !== setAppModal || $[3] !== type) {
    t2 = () => setAppModal({
      type,
      isOpened: false
    });
    $[2] = setAppModal;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const closeModal = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      type: MESSAGE_KEYWORD.CHECK_PERMISSION
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    request: requestCheckPermission
  } = useHandleApp(t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      type: MESSAGE_KEYWORD.NOTIFICATION
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    request: requestNotification,
    response: notificationResponse
  } = useHandleApp(t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      type: MESSAGE_KEYWORD.SYSTEM_SETTINGS
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    request: requestSystemSettings
  } = useHandleApp(t5);
  const [isSwiftPending, setIsSwiftPending] = useState(false);
  const [needsSettings, setNeedsSettings] = useState(false);
  let t6;
  let t7;
  if ($[8] !== isSwiftPending || $[9] !== requestNotification) {
    t6 = () => {
      if (!isSwiftPending) {
        return;
      }
      if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
        const id = setTimeout(requestNotification, 5000);
        return () => clearTimeout(id);
      }
    };
    t7 = [isSwiftPending, requestNotification];
    $[8] = isSwiftPending;
    $[9] = requestNotification;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[12] !== notificationResponse || $[13] !== requestCheckPermission || $[14] !== setAppModal || $[15] !== setTempDeviceTokenData) {
    t8 = () => {
      const {
        data,
        isSuccess
      } = notificationResponse ?? {};
      if (notificationResponse && !isSuccess) {
        const deniedData = data as unknown as {
          needsSettings?: boolean;
        } | undefined;
        if (deniedData?.needsSettings) {
          setNeedsSettings(true);
          setAppModal({
            type: "permission",
            isOpened: true
          });
        }
        return;
      }
      if (isSuccess && data) {
        if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
          if (data.fcm_token) {
            setTempDeviceTokenData(data);
            setIsSwiftPending(false);
          } else {
            setIsSwiftPending(true);
          }
        } else {
          setTempDeviceTokenData(data);
        }
        requestCheckPermission({
          permissionType: MESSAGE_KEYWORD.LOCATION
        });
      }
    };
    t9 = [notificationResponse, requestCheckPermission, setAppModal, setTempDeviceTokenData];
    $[12] = notificationResponse;
    $[13] = requestCheckPermission;
    $[14] = setAppModal;
    $[15] = setTempDeviceTokenData;
    $[16] = t8;
    $[17] = t9;
  } else {
    t8 = $[16];
    t9 = $[17];
  }
  useEffect(t8, t9);
  let t10;
  if ($[18] !== closeModal || $[19] !== needsSettings || $[20] !== type) {
    t10 = () => {
      if (needsSettings) {
        setNeedsSettings(false);
        closeModal();
        return;
      }
      if (type !== "permission" && type !== "forceUpdate") {
        closeModal();
      }
    };
    $[18] = closeModal;
    $[19] = needsSettings;
    $[20] = type;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== closeModal || $[23] !== needsSettings || $[24] !== osType || $[25] !== requestNotification || $[26] !== requestSystemSettings) {
    t11 = needsSettings ? <article className="flex flex-col items-center gap-8"><h2 className="text-center font-700 typo-h5">알림이 차단되어 있어요</h2><p className="mb-16 text-center text-Gray-600 typo-body4">기기 설정에서 알림을 허용하면<br />맞춤 정보를 받아볼 수 있어요.{osType !== "ios" ? <><br />설정 화면에서 「알림」을 눌러 켜주세요.</> : null}</p><Button onClick={() => {
        requestSystemSettings();
        setNeedsSettings(false);
        closeModal();
      }}>설정으로 이동</Button><Button theme="sub-text" onClick={() => {
        setNeedsSettings(false);
        closeModal();
      }}>다음에 할래요</Button></article> : <article className="flex h-full max-h-[70vh] flex-col"><h2 className="mb-8 font-700 typo-body1">서비스 이용을 위한<br />권한 접근이 필요해요.</h2><div className="flex flex-1 flex-col gap-20 overflow-y-auto"><section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">필수 접근 권한</h3><p className="text-Gray-600 typo-body4">필수적 접근 권한 없음</p></div></section><section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">선택적 접근 권한</h3><p className="text-Gray-600 typo-body4">선택적 접근 권한은 해당 기능을 사용할 때 허용이 필요하며, 비허용 시에도 해당 기능 외 서비스 이용이 가능합니다.</p></div><ul className="flex flex-col gap-10 px-16">{[{
              icon: Notification,
              title: "\uC54C\uB9BC(\uC120\uD0DD)",
              description: "\uAC1C\uC778\uBCC4 \uB9DE\uCDA4 \uC815\uBCF4 \uC54C\uB9BC"
            }, {
              icon: Location,
              title: "\uC704\uCE58(\uC120\uD0DD)",
              description: "\uAC80\uC0C9 \uBC0F \uB3D9\uB124\uC18C\uC2DD\uC5D0\uC11C \uD604\uC7AC \uC704\uCE58 \uC0AC\uC6A9"
            }, {
              icon: Camera,
              title: "\uCE74\uBA54\uB77C(\uC120\uD0DD)",
              description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
            }, {
              icon: ImgPicker,
              title: "\uC0AC\uC9C4(\uC120\uD0DD)",
              description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
            }].map(_temp2)}</ul></section><section className="flex flex-col gap-16 pb-16"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">접근 권한 변경 방법</h3><p className="text-Gray-600 typo-body4">휴대폰 설정 {">"} 앱 또는 애플리케이션 관리 {">"} 웰로{" "}{">"} 권한에서 각 권한별 변경 가능합니다.</p></div></section></div><Button className="mt-16" onClick={async () => {
        requestNotification();
        closeModal();
      }}>확인</Button></article>;
    $[22] = closeModal;
    $[23] = needsSettings;
    $[24] = osType;
    $[25] = requestNotification;
    $[26] = requestSystemSettings;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h2 className="text-center font-700 typo-h5">앱을 나가시겠어요?</h2>;
    t13 = <p className="mb-16 text-Gray-600 typo-body4">더이상 뒤로 갈 페이지가 없어요.</p>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t12 = $[28];
    t13 = $[29];
  }
  let t14;
  if ($[30] !== closeModal) {
    t14 = <Button onClick={closeModal}>계속 볼게요</Button>;
    $[30] = closeModal;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== requestExit) {
    t15 = <Button theme="sub-text" onClick={() => requestExit()}>나갈게요</Button>;
    $[32] = requestExit;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <article className="flex flex-col items-center gap-8">{t12}{t13}{t14}{t15}</article>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <h2 className="text-center font-700 typo-h5">앱이 업데이트 되었어요!</h2>;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <p className="mb-16 text-Gray-600 typo-body4">사용자들의 의견을 반영한 업데이트가 있어요.<br />업데이트 하고 신규 기능을 이용해 보세요.</p>;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== requestRestart) {
    t19 = <Button onClick={() => requestRestart()}>업데이트</Button>;
    $[39] = requestRestart;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== closeModal) {
    t20 = <Button theme="sub-text" onClick={closeModal}>다음에 할래요</Button>;
    $[41] = closeModal;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19 || $[44] !== t20) {
    t21 = <article className="flex flex-col items-center gap-8">{t17}{t18}{t19}{t20}</article>;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <h2 className="text-center font-700 typo-h5">업데이트가 필요해요</h2>;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <p className="mb-16 text-Gray-600 typo-body4">원활한 서비스 이용을 위해<br />최신 버전으로 업데이트해 주세요.</p>;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== osType) {
    t24 = <article className="flex flex-col items-center gap-8">{t22}{t23}<Button onClick={() => {
        window.location.href = getAppStoreUrls(osType === "ios" ? "ios" : "android").schemeUrl;
      }}>업데이트하기</Button></article>;
    $[48] = osType;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t11 || $[51] !== t16 || $[52] !== t21 || $[53] !== t24) {
    t25 = {
      permission: t11,
      exit: t16,
      restart: t21,
      forceUpdate: t24
    };
    $[50] = t11;
    $[51] = t16;
    $[52] = t21;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  const t26 = t25[type];
  let t27;
  if ($[55] !== isOpened || $[56] !== t10 || $[57] !== t26) {
    t27 = <ResponsiveDialog opened={isOpened} onClose={t10} drawerType="bottom">{t26}</ResponsiveDialog>;
    $[55] = isOpened;
    $[56] = t10;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  return t27;
};
function _temp(state) {
  return [state.appModal, state.setAppModal, state.setTempDeviceTokenData, state.osType];
}
function _temp2(t0, index) {
  const {
    icon: Icon,
    title,
    description
  } = t0;
  return <li key={index} className="flex items-center gap-16"><div className="size-48 rounded-pill bg-Gray-100 flex-center"><Icon alt={title} /></div><div className="flex flex-col gap-2"><h4 className="font-700 text-Gray-900 typo-body4">{title}</h4><p className="text-Gray-600 typo-body4">{description}</p></div></li>;
}